export default function Keterangan({ title = 'Keterangan', ...props }) {
  return (
    <div {...props}>
      <strong>{title}</strong>
      <div>
        <span className='text-danger'>*</span>: wajib diisi
      </div>
    </div>
  )
}